export const APP_ROUTE_BASE = '/';
export const APP_ROUTE_V2 = '/v2';
